import { ParsedUrlQuery } from 'querystring'
import {
  ActiveFilterItem,
  ActiveFilterPriceWithQueryType,
  ActiveFilters,
  ActiveFiltersPriceType
} from 'types/activeFiltersType'
import { FilterQueryItem } from 'types/filterQueryItem'

type ActiveFilterPriceAlias =
  | ActiveFilterPriceWithQueryType
  | ActiveFiltersPriceType

export const parseQueryFromActiveFilters = (
  query: ParsedUrlQuery,
  activeFilters: ActiveFilters<
    ActiveFilterItem | string,
    ActiveFilterPriceAlias
  >
): ParsedUrlQuery => {
  query.slug = null
  query[FilterQueryItem.COLOR] = activeFilters.colors?.map((color) =>
    convertActiveFilterItemsToQuery(color)
  )
  query[FilterQueryItem.PATTERN] = activeFilters.patterns?.map((pattern) =>
    convertActiveFilterItemsToQuery(pattern)
  )
  query[FilterQueryItem.MATERIAL] = activeFilters.materials?.map((material) =>
    convertActiveFilterItemsToQuery(material)
  )
  query[FilterQueryItem.NEWS] = activeFilters.news ? '1' : null
  query[FilterQueryItem.MANUFACTURER] = activeFilters.manufacturers?.map(
    (manufacturer) => convertActiveFilterItemsToQuery(manufacturer)
  )
  const price = convertPrice(activeFilters.price)
  query[FilterQueryItem.PRICE_MAX] = price.max?.toString()
  query[FilterQueryItem.PRICE_MIN] = price?.min?.toString()
  query[FilterQueryItem.SIZE] = activeFilters.sizes?.map((size) =>
    convertActiveFilterItemsToQuery(size)
  )
  query[FilterQueryItem.SORT] = convertActiveFilterItemsToQuery(
    activeFilters.sort
  )
  query[FilterQueryItem.STOCK] = activeFilters.inStock ? '1' : null
  query[FilterQueryItem.MAIN_WAREHOUSE] = activeFilters.inMainWarehouse
    ? '1'
    : null
  query[FilterQueryItem.IN_SALE] = activeFilters.inSale ? '1' : null
  query[FilterQueryItem.GENDER] = activeFilters.genders?.map((gender) =>
    convertActiveFilterItemsToQuery(gender)
  )
  query[FilterQueryItem.CATEGORY] = activeFilters.categories?.map((category) =>
    convertActiveFilterItemsToQuery(category)
  )
  if (activeFilters.tags) {
    activeFilters.tags.forEach(({ id, items }) => {
      query[FilterQueryItem.TAG.replace('{tagId}', id)] = items.map(
        ({ id }) => id
      )
    })
  }

  return query
}

const convertActiveFilterItemsToQuery = (
  item: ActiveFilterItem | string
): string | undefined => (typeof item === 'string' ? item : item?.id)

const convertPrice = (
  price?: ActiveFilterPriceAlias
): ActiveFiltersPriceType => {
  if ('min' in price || 'max' in price) {
    return { ...(price as ActiveFiltersPriceType) }
  }
  const query = price as ActiveFilterPriceWithQueryType
  return {
    min: query?.query?.min,
    max: query?.query?.max
  }
}
